module.exports = __webpack_public_path__ + "static/media/co-income.0b764170.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/co-income.png
// module id = 189
// module chunks = 0